import { _random, _size } from 'libs/lodash';

export const getRandomItem = <T>(itemsList: T[]): T => {
  const randomIndex = _random(0, _size(itemsList) - 1);

  return itemsList[randomIndex];
};
